export const formatRows = (listaItems) => 
    listaItems.map((item) => ({
      id: item.aju_id,
      aju_fecha: item.createdAt,
      sel_fullname: 
      item["ajustes_empleado"]?.sel_lastname && item["ajustes_empleado"]?.sel_firstname 
        ? `${item["ajustes_empleado"]?.sel_lastname}, ${item["ajustes_empleado"]?.sel_firstname}`
        : item["ajustes_empleado"]?.sel_lastname || item["ajustes_empleado"]?.sel_firstname || "Pagina Web",
      totalinventario: item.aju_total_art|| "0",
    }));
  